module.exports = __webpack_public_path__ + "img/EUR.77fe767f.gif";